import React, { Component } from 'react';

import PageTitle from '../../components/shared/page-title';
import SocialLogin from '../../components/auth/social';
import SignupForm from '../../components/forms/signup';
import LoginForm from '../../components/forms/login';

import style from './index.module.scss';

class LandingPage extends Component {
  state = {
    withEmail: false,
  };

  onChangeSignupMethod = () =>
    this.setState({ withEmail: !this.state.withEmail });

  render() {
    const currentYear = new Date().getFullYear();

    return (
      <>
        <PageTitle
          pageTitle='Quora - A place to share knowledge and better understand the world'
          pageDesc='Landing page of Quora'
        />
        <div className={style.landing}>
          <img
            src='https://imgur.com/lFaRXkE.png'
            alt='Mobile devices landing page top background'
            className={style['landing-top']}
          />
          <div className={`card ${style['landing-card']}`}>
            <img
              className={style['landing-logo']}
              src='https://i.imgur.com/K5gCLXM.png'
              alt='Quora Logo'
            />
            <p className={`text-muted ${style['landing-message']}`}>
              A place to share knowledge and better understand the world
            </p>
            <div className={`row ${style['landing-auth']}`}>
              <div
                style={{ paddingLeft: 0 }}
                className={`col-sm-12 col-md-6 ${style['signup-actions']}`}
              >
                {this.state.withEmail ? (
                  <SignupForm changeSignupMethod={this.onChangeSignupMethod} />
                ) : (
                  <SocialLogin changeSignupMethod={this.onChangeSignupMethod} />
                )}
              </div>
              <div
                style={{ paddingRight: 0 }}
                className={`col-sm-12 col-md-6 ${style['login-form']}`}
              >
                <LoginForm />
              </div>
            </div>
            <p className={style['landing-copyright']}>
              &copy; Quora {currentYear}
            </p>
          </div>
          <img
            src='https://imgur.com/wCBBB61.png'
            alt='Mobile devices landing page bottom background'
            className={style['landing-bottom']}
          />
        </div>
      </>
    );
  }
}

export default LandingPage;
